import {GET_CONFIGURATION, GET_LOG_OPERATIONS, GET_SYSTEM_INFORMATION} from "../types";

const INITIAL_STATE = {
    configuration:[],
    total:0,
    logOperations:[]
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_SYSTEM_INFORMATION:
            return {...state, ...action.payload};
        case GET_CONFIGURATION:
            return {...state, ...action.payload};
        case GET_LOG_OPERATIONS:
            return {...state, ...action.payload};
        default:
            return state;
    }
};